export const fonts = {
  gilroyBold: 'Gilroy Bold',
  gilroy: 'Gilroy',
  proximaNovaBold: 'Proxima Nova Bold',
  proximaNova: 'Proxima Nova',
  sansSerif: 'sans-serif',
};
